import { mapGetters, mapState } from 'vuex';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import Contract from '@/models/contract';
import marketContractInfoV2, { MARKET_CONTRACT_INFO_VALUES_LAYOUT } from '@/components/market/v2/market-contract-info-v2/market-contract-info-v2.vue';

export default {
  components: {
    marketChangePrice,
    marketContractInfoV2,
  },
  props: {
    type: {
      type: String,
      default: 'standalone',
    },
  },
  data() {
    return {
      MARKET_CONTRACT_INFO_VALUES_LAYOUT,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('market', ['sessionHistory']),
    classModifiers() {
      return {
        'session-history-sushi': true,
        [`session-history-sushi--${this.type}`]: this.type
      }
    },
    items() {
      return this.sessionHistory.map((i) => {
        const instance = new Contract(i)
        return {
          id: i.contractId,
          marketName: i.marketName,
          marketId: i.marketId,
          contractName: i.contractName,
          image: i.contractImageSmallUrl || i.contractImageUrl,
          price: instance.changePriceAsCents,
          priceAsCents: instance.lastTradePriceAsCents,
          hasLastTradePrice: instance.hasLastTradePrice,
          lastClosePrice: instance.lastClosePrice,
          contracts: [instance]
        }
      })
    },
  },
  methods: {
    itemLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query: { contractId: item.id }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/session-history-sushi/session-history-sushi.js